import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { BetRecorsApi } from '../Api/BetRecords';
import { DeleteBetApi } from '../Api/DeleteBet';
import { Flip, toast } from 'react-toastify';
import NumberBetModal from './Numberbetmodal';
import { Helmet } from 'react-helmet';

export default function BetHistory() {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const [isClient, setIsClient] = useState("");
    const [isGames, setIsGames] = useState("");
    const [betHistoryData, setBetHistoryData] = useState([]);

    const {
        setLoad,
        setLoadColor,
        numberModal,
        sideBarOpen,
        sessionDetail
    } = useContext(Context);

    // useCallback to memoize handleBetHistory and avoid unnecessary re-renders
    const handleBetHistory = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");

        const userinfo = JSON.parse(localStorage.getItem('userinfo'));
        const data = {
            username: userinfo?.username,
            client_name: isClient,
            game_name: isGames,
            user_id: userinfo?.userId
        };

        try {
            const res = await BetRecorsApi(data);
            if (res?.data?.status) {
                setBetHistoryData(res.data.data);
            } else {
                setBetHistoryData([]);
                toast.error(res?.data?.message || "Failed to fetch bet history", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } catch (err) {
            setBetHistoryData([]);
            toast.error("Something went wrong while fetching bet history.", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
        }
        setLoad(false);
    }, [isClient, isGames, setLoad, setLoadColor]);

    const handleClientChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsClient(value);
    };

    const handleGameChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsGames(value);
    };

    const deleteBetRecord = async (bet) => {
        console.log("deleteBetRecord ---> ", bet);
        const userinfo = JSON.parse(localStorage.getItem('userinfo'));
        const data = {
            username: userinfo?.username,
            user_id: userinfo?.userId,
            client_name: bet?.client_name,
            game_name: bet?.game_name,
            bet_numbers: bet?.bet_numbers,
            hruf_type: bet?.bet_type === "hruf" ? bet?.bet_data?.hruf_type || "" : ""
        };

        try {
            const res = await DeleteBetApi(data);
            if (res?.data?.status) {
                handleBetHistory();
                toast.success('Bet deleted successfully', {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            } else {
                toast.error(res?.data?.message || "Failed to delete bet", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } catch (error) {
            toast.error('Error deleting bet', {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
        }
    };

    // useEffect(() => {
    //     if (pathname === "/userBetsAndRevert" && !numberModal && !sideBarOpen) {
    //         handleBetHistory();
    //     }
    // }, [pathname, handleBetHistory, numberModal, sideBarOpen]);

    // useEffect(() => {
    //     if (pathname === "/userBetsAndRevert" && !numberModal && !sideBarOpen) {
    //         handleBetHistory();
    //     }
    // }, [isClient, isGames, handleBetHistory, numberModal, pathname, sideBarOpen]);
    useEffect(() => {
        if (pathname === "/userBetsAndRevert" && !numberModal && !sideBarOpen) {
            handleBetHistory();
        }
    }, [pathname, numberModal, sideBarOpen, isClient, isGames, handleBetHistory]);


    return (
        <>
            <NumberBetModal />
            <Helmet>
                {/* Page Title */}
                <title>Bet Revert | Revert Mistaken Bets in Bazar | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Allow clients to revert mistakenly placed bets in Matka Bazar such as Delhi Bazar. Manage and correct errors easily on MatkaJantri."
                />

                {/* SEO Directives */}
                <meta name="robots" content="noindex, nofollow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/bet-revert" />

                {/* Favicon and icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Bet Revert | Revert Mistaken Bets in Bazar | MatkaJantri" />
                <meta
                    property="og:description"
                    content="Allow clients to revert mistakenly placed bets in Matka Bazar such as Delhi Bazar. Manage and correct errors easily on MatkaJantri."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>

            <div className='depositContainer'>
                <div className="wrapper" style={{ marginTop: "0px" }}>
                    <div className="section">
                        <div className="top_navbar" style={{ height: "60px" }}>
                            <div className="hamburger">
                                {/* Use button for accessibility */}
                                <button className='back_btn' onClick={() => navigate("/game")}>
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                            </div>
                            <div className='gameName'>Jantri Bet History</div>
                        </div>
                    </div>
                </div>

                <div className="Tablecontainer betHistorytableCss">
                    <div className='SelectData'>
                        <div className='container-Section'>
                            <div className="select-section">
                                <select className="select-dropdown" onChange={handleClientChange}>
                                    <option value=''>Select Client</option>
                                    {sessionDetail?.user_clients?.map((client, index) => (
                                        <option key={index} value={client}>{client}</option>
                                    ))}
                                </select>
                                <select className="select-dropdown" onChange={handleGameChange}>
                                    <option value=''>Select Games</option>
                                    {sessionDetail?.user_games?.map((game, index) => (
                                        <option key={index} value={game}>{game}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>Client</th>
                                <th>Game</th>
                                <th>Type</th>
                                <th>Bet Data</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {betHistoryData?.length > 0 ? (
                                betHistoryData.map((ele, i) => (
                                    <tr key={i}>
                                        <td>{ele?.client_name}</td>
                                        <td>{ele?.game_name}</td>
                                        <td>{ele?.bet_type}</td>
                                        <td>
                                            <div style={{ maxHeight: "100px", overflowY: "auto", whiteSpace: "pre-wrap" }}>
                                                <span>{ele?.bet_data ? JSON.stringify(ele.bet_data, null, 2) : "No data available"}</span><br />
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                className="deleteButton"
                                                onClick={() => deleteBetRecord(ele)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No bet records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
